<div class="container">
    <div class="card pt-0 pr-0">
      <h4 class="main-head" *ngIf="!this.cancel">
        Capture Opportunities
      </h4>
      <h4 class="main-head" *ngIf="this.cancel">
        Cancel Opportunities
      </h4>
      <div class="tab-panels scrollbar" id="scrollcustom">
        <span *ngIf="this.load" class="load">{{loadMessage}}</span>
        <div [ngClass]="sensorDetails?.length > 1 ? 'table-container' : ''" *ngIf="!this.load">
        <div *ngFor="let reqElement of sensorDetails; let index = index" class="table-wrapper">
          <div style="display: flex;"> 
            <span class="sensor-name" >Sensor Name: {{ ((data?.currentUser?.obfuscated ? reqElement?.obfuscateName : reqElement?.displayName) || '') + ' ' + (reqElement?.sensor || '') }}</span>
            <div style="display: flex; gap: 7px;">
              <button *ngIf="isFilterAppliedMap[index] && isCapellaChecked && reqElement?.name === 'Capella'" class="custom-button"  (click)="resetFilter(index)">Reset</button>
              <button *ngIf="isCapellaChecked && reqElement?.name === 'Capella'"  [disabled]="!hasCapellaData(index)" mat-stroked-button class="submit" (click)="openFilterPopup(index)">Filter</button>
            </div>
            
          </div>
          <table mat-table [dataSource]="dataSource[index]" class="mat-elevation-z8"
          *ngIf="!reqElement?.loadMessage">
            <tr *matNoDataRow>
                <td colspan="100%" class="no-data">
                  <p>No opportunities found for selected time range.</p>
                </td>
              </tr>
            <ng-container matColumnDef="captureStart" style="flex: 1;">
              <mat-header-cell *matHeaderCellDef>
                <span>Date/time of Capture Start <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span></span>
              </mat-header-cell>
              <mat-cell class="frequency-cell" *matCellDef="let element">
                <span *ngIf="reqElement?.operatorKey != this.OPERATORS.SATELLOGIC"
                >{{timezone === 'UTC' ? (element?.captureStart | date: "dd/MM/yyyy - hh.mm a" : "GMT") : (formatDate(element?.captureStart))}}
                </span>
                <span *ngIf="reqElement?.operatorKey === this.OPERATORS.SATELLOGIC">
                  {{timezone === 'UTC' ? (element?.captureStart | date: "dd/MM/yyyy - hh.mm a") : (formatDate(element?.captureStart))}}
                </span>
              </mat-cell>
            </ng-container>
  
            <ng-container matColumnDef="captureEnd" style="flex: 1;">
              <mat-header-cell *matHeaderCellDef>
                <span> Date/time of Capture End <span *ngIf="this.timezone === 'UTC'">&nbsp; (UTC)</span></span>
              </mat-header-cell>
              <mat-cell class="frequency-cell tooltip-cell" *matCellDef="let element">
                <span style="width: 150px !important;" *ngIf="reqElement?.operatorKey != this.OPERATORS.SATELLOGIC">
                  {{timezone === 'UTC' ? (element?.captureEnd | date: "dd/MM/yyyy - hh.mm a" : "GMT") : (formatDate(element?.captureEnd))}}
                </span>
                <span style="width: 150px !important;" *ngIf="reqElement?.operatorKey === this.OPERATORS.SATELLOGIC">
                  {{timezone === 'UTC' ? (element?.captureEnd | date: "dd/MM/yyyy - hh.mm a") : (formatDate(element?.captureEnd))}} 
                </span>
  
            <span *ngIf="element?.metadata" #tooltipTrigger style="position: relative; display: inline-block;">
                  <img
                    style="cursor: pointer;"
                    width="15px"
                    [src]="tooltipImagePath"
                    (mouseenter)="getMetadata(tooltipTrigger, element)"
                    (mouseleave)="onMouseLeave()"
                  />

                  <ng-template #tooltipTemplate>
                    <div class="custom-tooltip-box">
                      <app-custom-tooltip
                        [metadata]="metaDataTooltip"
                        product="collection"
                      ></app-custom-tooltip>
                    </div>
                  </ng-template>
              </span>
               
              </mat-cell>
              <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
              <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
            </ng-container>
  
            <ng-container matColumnDef="preference" style="flex: 1;">
              <div class="preference">
                <mat-header-cell *matHeaderCellDef>
                  Preference
                    <img *ngIf="reqElement.operatorKey === this.OPERATORS.CAPELLA && sensorDetails?.length <= 1" style="cursor: pointer;" width="15px" src="../../../assets/images/union-copy.svg"
                      matTooltip="Capella SAR opportunities within your time of interest (TOI) are for information only and cannot be selected"
                      matTooltipPosition="above" />
                    <img *ngIf="reqElement.operatorKey === this.OPERATORS.CAPELLA && sensorDetails?.length > 1" style="cursor: pointer;" width="15px" src="../../../assets/images/union-copy.svg"
                      matTooltip="Capella SAR opportunities within your time of interest (TOI) are for information only and cannot be selected. However, you may narrow the opportunity window using a filter when there are many opportunities listed."
                      matTooltipPosition="above" />
                    <img *ngIf="reqElement.operatorKey === this.OPERATORS.UMBRA || reqElement.operatorKey === this.OPERATORS.AZISTA || reqElement.operatorKey === this.OPERATORS.SATELLOGIC || reqElement.operatorKey === this.OPERATORS.ECURS || reqElement.operatorKey === this.OPERATORS.BLACKSKY || reqElement.operatorKey === this.OPERATORS.AXELSPACE" style="cursor: pointer;" width="15px" src="../../../assets/images/union-copy.svg"
                      matTooltip="Select one opportunity from the list of opportunities"
                      matTooltipPosition="above" />
                    <img *ngIf="reqElement.operatorKey === this.OPERATORS.GEOSAT" style="cursor: pointer;" width="15px" src="../../../assets/images/union-copy.svg"
                      matTooltip="Rank preferences by selecting one or more opportunities"
                      matTooltipPosition="above" />
                </mat-header-cell>
              </div>
              <mat-cell class="frequency-cell" *matCellDef="let element; let i = index">
                <input *ngIf="!reqElement.singleInput" class="matOptionPreference"
                  type="text" [(ngModel)]="element.preference" maxlength="2" appNumericOnly (input)="assignPreferences(index)" />
                <input *ngIf="reqElement.singleInput" class="matOptionPreference" [disabled]="reqElement.SAR"
                  type="text" [(ngModel)]="element.preference" maxlength="1" #preferenceInput
                  (click)="handleInputClick(preferenceInput, element, index)" (keydown)="handleKeyDown($event)"
                  [matTooltip]="reqElement.SAR ? element?.sensorNameToggle + ' opportunities within your time of interest (TOI) are for information only' : ''" />
                <div *ngIf="element.validPreferenceOrder" class="error-message">
                  {{element.error}}
                </div>
              </mat-cell>
            </ng-container>
  
          </table>
          <span *ngIf="reqElement?.loadMessage">
            Sorry, no opportunities are available for the selected time of interest (TOI).<br>
            Please change the TOI and try again.
          </span>
        </div>
        </div>
      </div>

      <div *ngIf="this.cancel" class="btns">
        <button class="custom-button" (click)="onNoClick()">Close</button>
        <button mat-stroked-button style="margin-left: 16px !important;" class="submit" (click)="cancelOpportunity()" [disabled]="!this.enabled">Yes,
          Cancel</button>
      </div>
  
      <div *ngIf="!this.cancel" class="btns">
        <button class="custom-button" (click)="onNoClick()">Close</button>
        <button mat-stroked-button style="margin-left: 16px !important;" class="submit" (click)="save()"
          [disabled]="disable || (isData != sensorDetails?.length)">Save</button>
      </div>
    </div>
  </div>
  
